import React from 'react';
import AddTeamMemberModal from '../../team/AddTeamMemberModal';
import DomainSettingsModal from '../../team/DomainSettingsModal';
import MediaUpload from '../../team/MediaUpload';
import ClientForm from '../../team/ClientForm';
import ProjectForm from '../../team/ProjectForm';
import { toast } from 'react-toastify';

const Modals = ({
  isReadOnly,
  openAdd,
  setOpenAdd,
  openSettings,
  setOpenSettings,
  showMediaUpload,
  setShowMediaUpload,
  showClientForm,
  setShowClientForm,
  showProjectForm,
  setShowProjectForm,
  displayUser,
  displayTeam,
  user,
  addMember,
  removeMember,
  addAllowedDomain,
  removeAllowedDomain,
  toggleDomainRestriction,
  handleMediaUploadComplete,
  handleClientAdded,
  handleProjectAdded,
}) => {
  if (isReadOnly) return null;

  return (
    <>
      <AddTeamMemberModal
        isOpen={openAdd}
        onClose={() => setOpenAdd(false)}
        team={displayTeam}
        ownerUser={user}
        onAdd={async email => {
          try {
            await addMember(email);
            toast.success('Member added');
          } catch (e) {
            toast.error(e?.message || 'Failed to add');
            throw e;
          }
        }}
      />

      <DomainSettingsModal
        isOpen={openSettings}
        onClose={() => setOpenSettings(false)}
        team={displayTeam}
        onAddDomain={async domain => {
          try {
            await addAllowedDomain(domain);
            toast.success('Domain added');
          } catch (e) {
            toast.error(e?.message || 'Failed to add domain');
            throw e;
          }
        }}
        onRemoveDomain={async domain => {
          try {
            await removeAllowedDomain(domain);
            toast.success('Domain removed');
          } catch (e) {
            toast.error(e?.message || 'Failed to remove domain');
            throw e;
          }
        }}
        onToggleRestriction={async allowAny => {
          try {
            await toggleDomainRestriction(allowAny);
            toast.success(allowAny ? 'Any domain now allowed' : 'Domain restriction enabled');
          } catch (e) {
            toast.error(e?.message || 'Failed to update domain settings');
            throw e;
          }
        }}
      />

      {showMediaUpload && (
        <MediaUpload
          organizationId={displayUser?.uid || displayUser?.id}
          onUploadComplete={handleMediaUploadComplete}
          onClose={() => setShowMediaUpload(false)}
        />
      )}

      {showClientForm && (
        <ClientForm
          organizationId={displayUser?.uid || displayUser?.id}
          onClientAdded={handleClientAdded}
          onClose={() => setShowClientForm(false)}
        />
      )}

      {showProjectForm && (
        <ProjectForm
          organizationId={displayUser?.uid || displayUser?.id}
          onProjectAdded={handleProjectAdded}
          onClose={() => setShowProjectForm(false)}
        />
      )}
    </>
  );
};

export default Modals;
